import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeFr, 'fr');
import { DecimalPipe,formatNumber } from '@angular/common';

@Pipe({
    name: 'localizedDecimal',
    pure: false
})
export class LocalizedDecimalPipe implements PipeTransform {
  constructor(private translateService: TranslateService) { }

  transform(value: any): any {
    // if (!value){
    //   return value;
    // }
    var decimal_formatted =
         formatNumber(value,this.translateService.currentLang,"1.2-2")
    //const datePipe: DatePipe = new NumberPipe(this.translateService.currentLang);
    return decimal_formatted;
  }
}
